import React from 'react';
import Screen from './Screen';

type Kind = 'home' | 'about' | 'work' | 'blog' | 'faq' | 'gallery';

interface PageLayoutProps {
  kind: Kind;
  title: string;
  children?: React.ReactNode;
}

/**
 * Reusable: Image Header + Content Page layout
 * Blog ve diğer sayfalar için kullanılan standart düzen
 */
const PageLayout: React.FC<PageLayoutProps> = ({ kind, title, children }) => (
  <>
    <Screen kind={kind} title={title} />
    <section className={`screen-tail screen-tail--${kind}`} aria-label={`${title} içerik alanı`}>
      <div className="tail-container">
        {children}
      </div>
    </section>
  </>
);

export default PageLayout;
